import { ChangeEvent } from 'react';
import { Stack, SxProps, TextField, Theme } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { Language } from '@/core';
import { LanguagePicker, LanguageTypes } from '@/features';

type FormLanguageInputControllerProps = {
  label: string;
  controllerName: string;
  selectedLanguage: LanguageTypes;
  setSelectedLanguage: (selectedLanguage: LanguageTypes) => void;
  error?: boolean;
  errorText?: string;
  helperText?: string;
  fieldOnBlur?: () => void;
  sx?: SxProps<Theme>;
};

export const FormLanguageInputController = ({
  label,
  controllerName,
  selectedLanguage,
  setSelectedLanguage,
  error,
  errorText,
  helperText,
  fieldOnBlur,
  sx,
}: FormLanguageInputControllerProps) => {
  const { control } = useFormContext();
  return (
    <Stack sx={{ width: '100%' }}>
      <Controller
        name={controllerName}
        control={control}
        render={({ field: { value, onChange, onBlur, ...field } }) => {
          const currentValue: string = value ? value[selectedLanguage as keyof Language] : '';
          const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
            const newValue = e.target.value;
            onChange({
              ...value,
              [selectedLanguage]: newValue,
            });
          };
          return (
            <TextField
              {...field}
              value={currentValue}
              onBlur={() => {
                onBlur();
                fieldOnBlur?.();
              }}
              onChange={handleInputChange}
              label={label}
              fullWidth
              error={error}
              helperText={error && errorText ? errorText : helperText}
              InputProps={{
                endAdornment: (
                  <LanguagePicker
                    currentLanguage={selectedLanguage}
                    onChange={setSelectedLanguage}
                  />
                ),
              }}
              sx={sx}
            />
          );
        }}
      />
    </Stack>
  );
};
